import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { StylesGrid } from './components/StylesGrid';
import { Studio, Gallery } from './components/StudioGallery';
import { Testimonials } from './components/Testimonials';
import { BookingCTA, SocialLinks, MapSection } from './components/BookingSocialMap';
import { Footer } from './components/Footer';
import { Divider } from './components/Divider';
export function App() {
  return <div className="w-full min-h-screen bg-black text-white font-raleway selection:bg-gold selection:text-black" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Divider data-id="element-3" />
      <About data-id="element-4" />
      <Divider data-id="element-5" />
      <Gallery data-id="element-6" />
      <Divider data-id="element-7" />
      <StylesGrid data-id="element-8" />
      <Divider data-id="element-9" />
      <Studio data-id="element-10" />
      <Divider data-id="element-11" />
      <Testimonials data-id="element-12" />
      <Divider data-id="element-13" />
      <BookingCTA data-id="element-14" />
      <Divider data-id="element-15" />
      <SocialLinks data-id="element-16" />
      <Divider data-id="element-17" />
      <MapSection data-id="element-18" />
      <Footer data-id="element-19" />
    </div>;
}